import React, { memo, useContext } from 'react'

import { LanguageContext } from '../../../context/LanguageContext'

const TableNoResults = ({ message }) => {
    const { strings } = useContext(LanguageContext)

    return (
        <div data-testid={'no-results'} className={'no-results'}>
            <h1 className={'no-results__heading paragraph secondary'}>
                {message ? message : strings.noResultsFound}
            </h1>
            {!message && (
                <p className={' no-results__heading paragraph sub mt-5'}>
                    {strings.noResultsMessage}
                </p>
            )}
        </div>
    )
}

export default memo(TableNoResults)
